import styled from "styled-components";

export const FavoriteListContainer = styled.div`
margin-top: 32px;
 display: grid;
grid-template-columns: repeat(4, 258px);
  gap: 16px; 

  width: 100%;

`;

